import { render } from "./NoInternet.vue?vue&type=template&id=0945bf43&ts=true"
import script from "./NoInternet.vue?vue&type=script&lang=ts"
export * from "./NoInternet.vue?vue&type=script&lang=ts"

import "./NoInternet.vue?vue&type=style&index=0&id=0945bf43&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__